import React, { useState } from "react";
import { graphql, Link } from "gatsby";
import WhatChooseUs from "components/homepage/whyChooseUs";
import QuotePopUp from "components/popup/quotePopUp/index";
import MidText from "./midText";
import Layout from "components/layout";
import SEO from "components/seo";
import OptimizedImage from "hooks/OptimizedImage";
import loadable from "@loadable/component";

export const recentQuery = graphql`
  query recentQuery($limit: Int!, $skip: Int!) {
    allRecentPages(
      sort: { fields: [data___seo_project_create_date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          data {
            seo_h1
            seo_project_create_date
            seo_project_small_desc
            slug
          }
        }
      }
    }
  }
`;

export default function RecentTranslation(props) {
  const GetInTouch = loadable(() => import("components/getInTouch"));
  const [open, setOpen] = useState(false);

  const title = "Last Translation Projects - Case Studies - Tomedes";
  const description =
    "Recent translation projects and case studies by Tomedes – We've worked with over 95,000 customers and have a satisfaction rating of 97%.";
  const keywords = "Recent translations, case studies, translation services";
  const recentPagesData = props.data.allRecentPages.edges;
  const totalPages = props.pageContext.totalPages;
  const currentPage = props.pageContext.currentPage;
  var canonical = "/recent-translations.php";
  if (props.pageContext.currentPage !== 1) {
    canonical = "/recent-translations.php/p/" + props.pageContext.currentPage;
  }

  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={canonical}
      />
      <div className="bannerImage bg-midBlue text-white py-[80px]">
        <div className=" mx-auto sm:w-[90%] w-[80%] lg:max-w-7xl">
          <h1 className="text-4xl leading-[46px] sm:text-[40px] md:text-[48px] lg:text-60 sm:leading-[40px] lg:leading-[60px] inline-block font-semibold w-auto font-secondary">
            Last translation projects
          </h1>
          <br />
          <div className="lg:bg-black bg-opacity-50 bg-no-repeat lg:px-4 font-secondary text-[14px] sm:text-2xl mt-7 inline-flex flex-col lg:flex-row gap-4 lg:gap-5 lg:items-center lg:mt-7">
            <div className="flex items-center">
              <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
                lazyload={false}
              />
              <span className="font-secondary">24/7 Human Support</span>
            </div>
            <div className="flex items-center">
              <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
                lazyload={false}
              />
              <span className="font-secondary">1 Year Guarantee</span>
            </div>
            <div className="flex items-center">
              <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
                lazyload={false}
              />
              <span className="content-left font-secondary">
                95,000 Business Customers
              </span>
            </div>
          </div>
          <div className="grid grid-cols-1 py-6 space-y-6 text-center md:flex md:flex-row md:align-baseline md:items-center md:space-x-6 md:space-y-0 font-opensans mt-7">
            <Link
              to="/quote"
              className="fr-btn1 tomedes-button green-btn-hv text-new uppercase rounded-full py-4 bg-orange text-white text-sm cursor-pointer w-60  font-semibold font-opensans hover:bg-[#ff9a16] transition-colors duration-300"
            >
              Get a Free Quote
            </Link>
            <a
              onClick={() => setOpen(true)}
              className="hidden sm:inline-block fr-btn2 tomedes-button uppercase rounded-full bg-white py-4 text-black cursor-pointer w-60 font-semibold font-opensans text-lg"
            >
              Contact Us
            </a>
            <Link
              to="/contactus.php"
              className="sm:hidden fr-btn2 tomedes-button uppercase rounded-full bg-white py-4 text-black cursor-pointer w-60 font-semibold font-opensans text-lg"
            >
              Contact us
            </Link>
          </div>
        </div>
      </div>
      <QuotePopUp open={open} setOpen={setOpen} />
      <MidText
        recentPagesData={recentPagesData}
        totalPages={totalPages}
        currentPage={currentPage}
      />
      {/* <WhatChooseUs backgroundCol="bg-darkBlue" /> */}
      <GetInTouch />
    </Layout>
  );
}